/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import AddEditResponseActivity from './add-edit-response-activity';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';

export default class BulkResponseActivity extends AddEditResponseActivity {
  isBulk = true;

  @tracked
  dialogOpen = false;

  @tracked
  mode = 'form';

  @tracked
  inProgress = false;

  @tracked
  completedDate = null;

  @action
  setCompletedDate(value) {
    this.completedDate = value;
  }

  @tracked
  responseActivityValue = null;

  @tracked
  detail = null;

  @action
  setDetail(option) {
    this.detail = option;
  }

  @tracked
  completedBy = null;

  @action
  setCompletedBy(value) {
    this.completedBy = value;
  }

  @tracked
  notes = null;

  @action
  setNotes(value) {
    this.notes = value;
  }

  @tracked
  hideNotes = false;

  @action
  setHideNotes(value) {
    this.hideNotes = value;
  }

  @computed('session.person')
  get activityRecordedBy() {
    return this.get('session.person');
  }

  isDateValid(validations, value) {
    return validations.every(({ validate }) => validate(value));
  }

  getCurrentThresholdValue(thresholds) {
    if (isEmpty(thresholds)) {
      return null;
    }
    let threshold = sortBy(thresholds, 'date').at(-1);
    return threshold ? threshold.threshold : null;
  }

  @computed('selectedLearners.[]', 'currTermThresholdsMap')
  get learnersWithThresholds() {
    return this.selectedLearners.filter((learner) => {
      let thresholds = this.currTermThresholdsMap[learner.id];
      return !isEmpty(this.getCurrentThresholdValue(thresholds));
    });
  }

  @computed('learnersWithThresholds.length')
  get eligibleCount() {
    return this.learnersWithThresholds.length;
  }

  resetForm() {
    this.mode = 'form';
    this.completedDate = null;
    this.responseActivityValue = null;
    this.detail = null;
    this.completedBy = null;
    this.notes = null;
    this.hideNotes = false;
  }

  @action
  noop() {}

  @action
  openDialog() {
    this.resetForm();
    this.dialogOpen = true;
  }

  @action
  closeDialog() {
    this.resetForm();
    this.dialogOpen = false;
  }

  @action
  setResponseActivity(option) {
    this.responseActivityValue = option.value;
    this.detail = null;
  }

  @action
  clearCompletedBy() {
    this.completedBy = null;
  }

  @action
  nextStep() {
    this.mode = 'review';
  }

  @action
  back() {
    this.mode = 'form';
  }

  @action
  createAll() {
    this.inProgress = true;

    let promises = this.learnersWithThresholds.map((learner) => {
      let record = this.store.createRecord('attendance/response-activity', {
        schoolId: this.get('session.school'),
        personId: learner,
        recordedById: this.get('session.person'),
        completedDate: this.completedDate,
        responseActivity: this.responseActivityValue,
        detail: this.detail,
        completedBy: this.completedBy,
        notes: this.notes,
        hideNotes: this.hideNotes,
      });
      return record.save();
    });

    let count = promises.length;
    let label = count === 1 ? 'Activity' : 'Activities';
    Promise.all(promises)
      .then(() => {
        this.toaster.success(
          `${count} Response ${label} created successfully.`,
        );
      })
      .catch(() => {
        this.toaster.error(`Error creating Response ${label}.`);
      })
      .finally(() => {
        this.closeDialog();
        this.inProgress = false;
      });
  }
}
